module.exports = __webpack_public_path__ + "static/media/wrl1.png.0eb331f5.jpg";